import { usePermission } from '@/lib/hooks/use-permission'
import {
    MdAdd,
    MdAssignment,
    MdLocalHospital,
    MdPerson,
} from 'react-icons/md'
import { Link } from 'react-router-dom'

interface QuickActionsWidgetProps {
    isHealth: boolean
}

interface ActionDef {
    label: string
    icon: any
    href: string
    color: string
    module: string
    resource: string
    healthOnly?: boolean
}

export default function QuickActionsWidget({ isHealth }: QuickActionsWidgetProps) {
    const { canCreate } = usePermission()

    const allActions: ActionDef[] = [
        {
            label: 'Novo Cliente',
            icon: MdPerson,
            href: '/person/clients/new',
            color: 'primary',
            module: 'person',
            resource: 'clients',
        },
        {
            label: 'Nova Consulta',
            icon: MdLocalHospital,
            href: '/bookings/consultations/new',
            color: 'info',
            module: 'bookings',
            resource: 'consultations',
        },
        {
            label: 'Nova Triagem',
            icon: MdAssignment,
            href: '/bookings/triage/new',
            color: 'warning',
            module: 'bookings',
            resource: 'triage',
            healthOnly: true,
        },
    ]

    const actions = allActions.filter(action => {
        if (action.healthOnly && !isHealth) return false
        return canCreate(action.module, action.resource)
    })

    if (actions.length === 0) return null

    return (
        <div className="bg-base-100 rounded-xl border border-base-300/50 overflow-hidden">
            <div className="bg-gradient-to-r from-accent/10 to-info/10 px-5 py-4 border-b border-base-300/50">
                <div className="flex items-center gap-3">
                    <div className="p-2 rounded-lg bg-accent/20">
                        <MdAdd className="text-accent text-lg" />
                    </div>
                    <div>
                        <h3 className="text-lg font-semibold text-base-content">
                            Ações Rápidas
                        </h3>
                        <p className="text-xs text-base-content/60">
                            Crie novos registros
                        </p>
                    </div>
                </div>
            </div>

            <div className="p-4">
                <div className="grid grid-cols-2 gap-3">
                    {actions.map((action, index) => {
                        const Icon = action.icon
                        return (
                            <Link
                                key={index}
                                to={action.href}
                                className={`group flex flex-col items-center gap-2 p-4 rounded-xl bg-${action.color}/5 border border-${action.color}/20 hover:border-${action.color}/40 hover:shadow-lg transition-all`}
                            >
                                <div
                                    className={`p-3 rounded-xl bg-${action.color}/10 group-hover:bg-${action.color}/20 transition-colors`}
                                >
                                    <Icon className={`text-2xl text-${action.color}`} />
                                </div>
                                <span className="text-sm font-medium text-base-content text-center">
                                    {action.label}
                                </span>
                            </Link>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}
